// MUI theme matched to the Tailwind/CSS tokens (design guide §2, §7) —
// LIGHT since the 2026-09-11 redesign, reading styles/colors.js.
// MUI is reserved for complex widgets; everything else is Tailwind + custom CSS.
// The one MUI surface in the app today is the Tooltip — the receipt chip's
// (PlayBody) and the header counter's (components/SegBadge, 2026-09-29):
// its face is themed HERE — card2 surface, hairline, the --fs-sm / --r-sm
// ladder steps — so no sx prop restyles it at the call site.
import { createTheme } from "@mui/material/styles";

import { COLORS } from "styles/colors";

const muiTheme = createTheme({
  palette: {
    mode: "light",
    background: { default: COLORS.bg, paper: COLORS.card },
    primary: { main: COLORS.accent },
    success: { main: COLORS.green },
    error: { main: COLORS.red },
    warning: { main: COLORS.gold },
    text: { primary: COLORS.txt, secondary: COLORS.txt2 },
    divider: COLORS.line2,
  },
  shape: { borderRadius: 8 }, // --r-sm: the popover/tooltip step of the ladder
  typography: {
    // the ONE typeface — read from index.css :root, so MUI can never drift
    // off the app's stack (the tooltip renders inside the document)
    fontFamily: "var(--font-sans)",
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          maxWidth: 280,
          fontSize: 12, // --fs-sm
          lineHeight: 1.45,
          color: COLORS.txt,
          background: COLORS.card2,
          border: `1px solid ${COLORS.line2}`,
          borderRadius: 8,
          padding: "8px 10px",
          boxShadow: "0 4px 14px rgba(20,32,27,.08)", // --shadow-sm
        },
        arrow: { color: COLORS.card2 },
      },
    },
  },
});

export default muiTheme;
